import Helpers from './helpers';
import GooglePublisherTag from './controllers/gpt';

// Include css for demo if constant is set true
if ( typeof DEMO !== 'undefined' && DEMO ) {
  require('./demo.css');
}

( async () => {

  // Check ADVERTISING_PAGE_DATA exists, bail out and warn if not.
  if ( typeof ADVERTISING_PAGE_DATA === 'undefined' ) {
    console.log( 'No page level advertising data found, GPT & Prebid not loaded' );
    return;
  }

  // Initialise Legacy site skin / homepage takeover theme integration
  window.dfp = window.dfp || {};
  window.dfp.takeover = function ( data ) {
    Helpers.legacyTakeover( data );
  };

  // Wait for transparency and consent framework api to load
  let loaded = await Helpers.tcfLoaded( 10000 );

  // Once loaded proceed, otherwise indicate timeout reached
  if ( loaded !== true ) {
    console.log( 'Consent API timed out, GPT & Prebid not loaded' );
    return;
  }

//////////////////////////////

///////////////////////////////////////////////////
//////////////////
////////////////////////////////////
//////////////////////////////////////////////
//////

////////////
//////////////////////////////////////////////////////////
////////////////////////////////////////////////
/////////
//////////////////////////////////
////////////////////////////////////////////
///////////////////////////////////////
///

///////////////////////////////////////////////
//////////////////////////////////////////////////////////
//////////////////
////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////
//////////////////////////////////////////////////////
////////////////////
///////////////////////////////////
//////////
////////
///////////////
///////
/////

////////////

  // Wait for transparency and consent framework data
  let tcData = await Helpers.tcfDataReady();

  // If GDPR doesn't apply proceed
  if ( ! tcData.gdprApplies ) {

    console.log( 'GDPR not required' );

    // Insert Google Publisher Tag script & Run DFP Logic
    await GooglePublisherTag.enable( tcData );

  // If GDPR applies test for consent and proceed
  } else {

    const hasDeviceStorageAndAccessConsent = tcData.purpose.consents[ 1 ] || false;

    if ( hasDeviceStorageAndAccessConsent ) {

      const hasGoogleAdvertisingProductsConsent = tcData.vendor.consents[ 755 ] || false;

      if ( hasGoogleAdvertisingProductsConsent ) {

        console.log( 'GDPR & Consent' );

        // Insert Google Publisher Tag script & Run DFP Logic
        await GooglePublisherTag.enable( tcData );
      }

    }

  }

})();
